<template>
  <BaseTabList
    class="pb-router-tablist"
    scrollable
  >
    <slot />
    <BaseTab
      nopadding
      class="pb-router-tab pb-router-tab-add"
      :disabled="readonly"
      :class="{ 'pb-router-tab-add-disabled': readonly }"
    >
      <BaseButton
        class="pb-router-tab-button"
        :tooltip="addTitle"
        @click="add"
      >
        <i class="icon-add" />
      </BaseButton>
    </BaseTab>
  </BaseTabList>
</template>

<script setup>
import BaseTabList from '@nicolaudie-group/ng-ui-kit/components/BaseTab/BaseTabList.vue'
import BaseTab from '@nicolaudie-group/ng-ui-kit/components/BaseTab/BaseTab.vue'
import BaseButton from '@nicolaudie-group/ng-ui-kit/components/BaseButton/BaseButton.vue'

import { useReadonly } from '@/composables/useProfile'

defineProps({
  addTitle: { type: String, default: 'Add' },
})

const emit = defineEmits(['add'])

const readonly = useReadonly()

function add() {
  if (!readonly.value) {
    return emit('add')
  }
  return undefined
}
</script>

<style lang="scss" src="./RouterTabList.scss" />
